import { Link } from "gatsby";
import React, { Fragment } from "react";
import { getStoredFilterValue } from "../helpers/postOverviewFilterStorage";
import useMediaQuery from "../hooks/useMediaQuery";
import ArrowLeftIcon from "./icons/ArrowLeftIcon";
import ChevronRightIcon from "./icons/ChevronRightIcon";
import HomeIcon from "./icons/HomeIcon";

export type BreadcrumbItem = {
  label: string;
  path: string;
};
interface Props {
  breadcrumbItems: BreadcrumbItem[];
}

// If the target page has a filter selection stored (e.g. the user came from it with a filter
// applied), link to it with that filter still applied instead of its plain path
const getHref = (path: string) => {
  const filter = getStoredFilterValue(path);
  return filter ? `${path}?${filter}` : path;
};

const Breadcrumbs = ({ breadcrumbItems }: Props) => {
  const isBelowSm = useMediaQuery("below", "sm");
  const previewPage = breadcrumbItems
    .slice()
    .reverse()
    .find((item) => item.path);

  return (
    <div
      className="mx-4 mt-5 flex items-center gap-2 text-sm sm:mx-8 sm:mt-6 [&>svg]:-ml-0.5"
      data-datocms-noindex
    >
      {!isBelowSm ? (
        breadcrumbItems.map((item, index) => {
          return (
            <Fragment key={index}>
              {index === 0 ? (
                <Link to={getHref(item.path)} className="h-[15px]">
                  <HomeIcon size={12} />
                </Link>
              ) : item.path ? (
                <Link to={getHref(item.path)}>{item.label}</Link>
              ) : (
                <span className="text-gray-700">{item.label}</span>
              )}
              {index < breadcrumbItems.length - 1 && (
                <ChevronRightIcon size={8} />
              )}
            </Fragment>
          );
        })
      ) : (
        <>
          <Link
            to={getHref(previewPage.path)}
            className=" flex items-center gap-2 [&>svg]:hover:text-teal-600 [&>svg]:focus:text-teal-600"
          >
            <ArrowLeftIcon size={10} />
            {previewPage.label}
          </Link>
        </>
      )}
    </div>
  );
};

export default Breadcrumbs;
